import $ from 'jquery';
const guid = () => {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}

function zeroFill( number, width = 2 )
{
  width -= number.toString().length;
  if ( width > 0 )
  {
    return new Array( width + (/\./.test( number ) ? 2 : 1) ).join( '0' ) + number;
  }
  return number + ""; // always return a string
}

$.fn.youtubeSlider = function(options) {

    // This is the easiest way to have default options.
    const settings = $.extend({

    }, options );

    const getVideoId = (url) => {
        var video_id = url.split('v=')[1];
        var ampersandPosition = video_id.indexOf('&');
        if(ampersandPosition != -1) {
            video_id = video_id.substring(0, ampersandPosition);
        }
        return video_id;
    }


    return this.each(function() {
        const view =  $(this).find('.video-slider--view');
        const thumbs = $(this).find('.video-slider--item');
        let container = $(this)
        let interval = null
        const clearTimer = () => {
            if(interval){
                clearInterval(interval)
            }
        }


        let player;
        let paused = false;


        function cancel(){
            let el = container.find('.video-slider--item.playing')
            el.removeClass('playing');
            el.find('.video-slider--video-controls').remove();
            el.data('started',false);
            clearTimer();
            el.find('.timer').html(el.attr('data-time'));
            paused = false;
        }
        view.on('click', function () {
            if($(this).find('.video-slider--image').length){
                thumbs.first().trigger('click');
            }
        });
        thumbs.on('click',function(e){

            e.preventDefault()

            if($(this).data('started') === true){
                if(paused){
                    player.playVideo();
                }else{
                    player.pauseVideo();
                }
                return ;
            }

            cancel();
            $(this).addClass('playing');

            const svg = '<svg class="video-slider--progress" version="1.1"  xmlns="http://www.w3.org/2000/svg"><circle r="35" cx="50" cy="50"/></svg>';

            const controls = $(`<div class="video-slider--video-controls">${svg}</div>`);

            const progress = controls.find('svg circle');

            let url = getVideoId($(this).attr('data-video'));
            let id = `player-${guid()}`;

            $(this).append(controls);
            $(this).data('started',true);
            view.html('');
            view.append(`<div id="${id}"></div>`);
            let totalTime =0;
            let currentTime = 0;
            let circle = 332;

            let element = $(this);

            const startInerval = (currentTime,totalTime) => {
                clearTimer();
                interval = setInterval(() => {
                    let val = currentTime  / totalTime ;
                    val = parseFloat(val.toFixed(3),10)
                    let strokeDashOffsetValue = 300 - (val * 300)  ;
                    progress.css("stroke-dashoffset", strokeDashOffsetValue);

                    var minutes = Math.floor((totalTime - currentTime) % 3600 / 60);
                    var seconds = Math.floor((totalTime - currentTime) % 3600 % 60);

                    element.find('.timer').html(`${zeroFill(minutes)}:${zeroFill(seconds)}`)

                    currentTime++;
                },1000);
            }

            player = new YT.Player(id, {
                height: '495',
                width: '890',
                videoId: url,
                playerVars: {
                    rel: 0,
                    showinfo:false
                },
                events: {
                    onReady: function(event){
                        let duration = event.target.getDuration();
                        event.target.playVideo();
                        startInerval(0,duration);
                    },
                    onStateChange: function(event){
                        paused = false;
                        element.removeClass('paused')
                        switch(event.data){
                            case YT.PlayerState.UNSTARTED:

                            break;

                            case YT.PlayerState.ENDED:
                                clearTimer();
                            break;

                            case YT.PlayerState.PLAYING:
                                startInerval(event.target.getCurrentTime() , event.target.getDuration())
                            break;
                            case YT.PlayerState.PAUSED:
                                paused = true;
                                element.addClass('paused')
                                clearTimer();
                            break;
                            case YT.PlayerState.BUFFERING:
                                clearTimer();
                            break;
                            case YT.PlayerState.CUED:

                            break;
                        }
                    }
                }
            });
        });

    });
}
export class YoutubeSlider {
    constructor(selector,options = {}){
        YoutubeSlider.writeScripts();

        $(selector).youtubeSlider(options)
    }

    static writeScripts(){
        if(YoutubeSlider.scriptsWrited){
            return ;
        }
        // 2. This code loads the IFrame Player API code asynchronously.
        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        YoutubeSlider.scriptsWrited = true
    }
}

YoutubeSlider.scriptsWrited = false;



// WEBPACK FOOTER //
// ./src/scripts/Youtube.js